import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { User } from '../../types'
import { hasRole } from '../../utils'
import RoleType from '../../types/enums/RoleType'

export interface CurrentUserState {
  currentUser: User | null
  isManagement: boolean
  isManagementOrAdministrator: boolean
  isLeader: boolean
  isProjectLeader: boolean
  isEmployee: boolean
  isRecruiter: boolean
  isHR: boolean
  isBaseUser: boolean
  isAdmin: boolean
}

const initialState: CurrentUserState = {
  currentUser: null,
  isManagement: false,
  isManagementOrAdministrator: false,
  isLeader: false,
  isProjectLeader: false,
  isEmployee: false,
  isRecruiter: false,
  isHR: false,
  isBaseUser: false,
  isAdmin: false,
}

export const currentUserSlice = createSlice({
  name: 'currentUser',
  initialState,
  reducers: {
    setCurrentUser: (state, action: PayloadAction<{ currentUser: User }>) => {
      const user = action.payload.currentUser
      const roles = user?.roles
      state.currentUser = user
      state.isManagement = hasRole([RoleType.Management], roles)
      state.isManagementOrAdministrator = hasRole([RoleType.Management, RoleType.Admin], roles)
      state.isLeader = hasRole([RoleType.Leader], roles)
      state.isProjectLeader = hasRole([RoleType.ProjectLeader], roles)
      state.isEmployee = hasRole([RoleType.Employee], roles)
      state.isRecruiter = hasRole([RoleType.Recruiter], roles)
      state.isHR = hasRole([RoleType.HR], roles)
      state.isBaseUser = hasRole([RoleType.BaseUser], roles)
      state.isAdmin = hasRole([RoleType.Admin], roles)
    },
  },
})

export const getCurrentUser = (state: RootState) => state.currentUser.currentUser
export const getIsManagement = (state: RootState) => state.currentUser.isManagement
export const getIsManagementOrAdministrator = (state: RootState) => state.currentUser.isManagementOrAdministrator
export const getIsLeader = (state: RootState) => state.currentUser.isLeader
export const getIsProjectLeader = (state: RootState) => state.currentUser.isProjectLeader
export const getIsEmployee = (state: RootState) => state.currentUser.isEmployee
export const getIsRecruiter = (state: RootState) => state.currentUser.isRecruiter
export const getIsHR = (state: RootState) => state.currentUser.isHR
export const getIsBaseUser = (state: RootState) => state.currentUser.isBaseUser
export const getIsAdmin = (state: RootState) => state.currentUser.isAdmin
export const getIsLeaderOrManagement = (state: RootState) =>
  state.currentUser.isLeader || state.currentUser.isManagement
export const getIsLeaderAndNotManagement = (state: RootState) =>
  state.currentUser.isLeader && !state.currentUser.isManagement

export const currentUserActions = currentUserSlice.actions
export const currentUserReducer = currentUserSlice.reducer

export default currentUserReducer
